module.exports = __webpack_public_path__ + "static/media/person-outlined-icon.4e39eb68.svg";